<template>
    <div v-show="validationResult && validationResult.messages && validationResult.messages.length > 0">
        <span class="body-1 red--text">{{header}}</span>
        <ul class="body-1 red--text">
            <li v-for="message in validationResult.messages" v-bind:key="message">{{ message }}</li>
        </ul>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'

export default {
    name: 'validationResultDisplay',
    props: {
        validationResult: { default: {} },
        header: { default: 'Please correct the following validation issue(s):' }
    },
    data: function () {
        return {
            isDebug: false
        }
    },
    created () {
        loggingService.log(this.isDebug, 'validationResultDisplay', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'validationResultDisplay', 'mounted')
    }
}
</script>
